//https://developers.google.com/analytics/devguides/collection/ga4/reference/events#view_cart

class ViewCartEventListener {
    // Language: javascript
    // Path: ViewCartEventListener.js
    // Compare this snippet from EventListener.js:

    constructor(element, eventName = "show") {
        this.element = element;
        this.eventName = eventName;
    }

    callback() {
        const dataLayer = new DataLayer();
        dataLayer.clear();

        var cartItems = document.querySelectorAll(".gtm-view-cart");
        var quantites =
            document.querySelectorAll(".gtm-view-cart .number-unit input")
                .length > 0
                ? document.querySelectorAll(".gtm-view-cart .number-unit input")
                : document.querySelectorAll(
                      ".cart-body__quantity-control-input"
                  );

        var totalPrice;
        var items = [];
        var currency;

        for (var i = 0; i < cartItems.length; i++) {
            var cartItem = cartItems[i];
            var analyticsData = cartItem.dataset.analytics
                ? JSON.parse(cartItem.dataset.analytics)
                : null;

            if (analyticsData && cartItem.dataset) {
                var analticsDataProducts = analyticsData.products
                    ? analyticsData.products[0]
                    : null;
                var quantity = parseFloat(quantites[i].value);
                totalPrice = cartItem.dataset.total;
                currency = cartItem.dataset.cartcurrency;

                var price = Number(
                    analticsDataProducts.price.replace(",", ".")
                ).toFixed(2);
                var pricewithdiscount = Number(
                    analticsDataProducts.pricewithdiscount.replace(",", ".")
                ).toFixed(2);
                var item = {
                    item_id: analticsDataProducts.code,
                    item_name: analticsDataProducts.name,
                    currency: analticsDataProducts.currency,
                    item_brand: analticsDataProducts.brand,
                    item_category: analticsDataProducts.category,
                    price: pricewithdiscount,
                    quantity: quantity,
                };

                if (analticsDataProducts.categories) {
                    var splitCategories =
                        analticsDataProducts.categories.split(";");
                    for (var j = 0; j < splitCategories.length; j++) {
                        if (j == 0) {
                            item["item_category"] = splitCategories[j];
                        } else {
                            item["item_category" + j] = splitCategories[j];
                        }
                    }
                }

                if (cartItem.dataset.variant) {
                    var variant = JSON.parse(cartItem.dataset.variant);
                    if (variant) {
                        item["item_variant"] = Object.values(variant).join(",");
                    }
                }

                if (price != pricewithdiscount) {
                    item["price"] = analticsDataProducts.price;
                    item["discount"] = (price - pricewithdiscount).toFixed(2);
                }

                items.push(item);
            }
        }

        if (cartItems.length > 0) {
            SendData(dataLayer);
        }

        function SendData(dataLayer) {
            dataLayer
                .push({
                    event: "view_cart",
                    ecommerce: {
                        currency: currency,
                        value: totalPrice,
                        items: items,
                    },
                })
                .then(() => {
                    console.log("GTM pushed view_cart event");
                    setTimeout(() => {
                        var instanceActivate = new ActivateGtm();
                        instanceActivate.activateRemoveFromCart();
                    }, 2000);
                })
                .catch((error) => {
                    console.warn("GTM error view_cart event", error);
                });

            if (typeof gtag !== "undefined" && !!gtag) {
                gtag("event", "view_cart", {
                    event_category: "Enhanced Ecommerce",
                    event_label: "view cart",
                    value: totalPrice,
                    currency: currency,
                    items: items,
                });
            }
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            ViewCartEventListener.prototype.callback
        );
    }

    remove() {
        this.element.addEventListener(
            this.eventName,
            ViewCartEventListener.prototype.callback
        );
    }
}
